import { useAuth } from '../context/AuthContext';
import { hasRight, hasAnyRight, hasAllRights } from '../utils/jwtUtils';

/**
 * Hook for checking user rights
 */
export const useRights = () => {
  const { rights, userType } = useAuth();

  // SuperAdmin has all rights
  const isSuperAdmin = userType === 'SUPER_ADMIN';

  return {
    rights,
    hasRight: (right: string) => isSuperAdmin || hasRight(rights, right),
    hasAnyRight: (requiredRights: string[]) => isSuperAdmin || hasAnyRight(rights, requiredRights),
    hasAllRights: (requiredRights: string[]) => isSuperAdmin || hasAllRights(rights, requiredRights),
    isSuperAdmin,
  };
};

